import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Divider, IconButton, Link, Typography } from '@mui/material';
import { setupContentUrl, setupCurrentOriginUrl } from 'utils/contentUtils';
import { SOCIAL, STORES } from './Footer.consts';
import useFooter from './useFooter';

const Footer = () => {
  const { labels, data, openFooterTab, toggleFooterTab } = useFooter();
  return (
    <footer id="footer" data-site="help">
      <section className="bg-grey px-3 py-4 pb-md-5 pt-md-3">
        <div className="container-xl">
          <div className="row gy-3">
            {Array.isArray(data?.footerColumns) &&
              data.footerColumns.map((parent, parentIndex) => {
                const parentHref = setupCurrentOriginUrl(parent.href);
                return (
                  <div key={parent.id} className="col-12 col-md-6 col-lg">
                    {parentIndex > 0 && <Divider className="w-100 mb-3 d-md-none opacity-100" />}
                    <div className="d-flex align-items-center flex-nowrap">
                      <div className="flex-grow-1 flex-shrink-1">
                        {parentHref ? (
                          <Link
                            href={parentHref}
                            target="_self"
                            color="textPrimary"
                            underline="none"
                            className="d-none d-md-inline-block pt-4 pb-4"
                          >
                            <Typography component="span" variant="h6" noWrap className="fw-semibold fs-6">
                              {parent.label}
                            </Typography>
                          </Link>
                        ) : (
                          <Typography
                            component="span"
                            color="textPrimary"
                            variant="h6"
                            noWrap
                            className="d-none d-md-inline-block pt-4 pb-4 fw-semibold fs-6"
                          >
                            {parent.label}
                          </Typography>
                        )}
                      </div>
                      {Array.isArray(parent.links) && parent.links.length > 0 && (
                        <Link
                          href="#"
                          color="textPrimary"
                          underline="none"
                          className="d-flex align-items-center justify-content-center d-md-none w-100 py-2"
                          onClick={(e) => {
                            e.preventDefault();
                            toggleFooterTab(parent.id);
                          }}
                        >
                          <Typography
                            component="span"
                            variant="h6"
                            noWrap
                            className="fw-semibold fs-6 flex-grow-1 flex-shrink-1"
                          >
                            {parent.label}
                          </Typography>
                          {openFooterTab[parent.id] ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </Link>
                      )}
                    </div>
                    {Array.isArray(parent.links) && parent.links.length > 0 && (
                      <>
                        <div className="row gy-3 d-none d-md-flex">
                          {parent.links.map((child) => {
                            const childHref = setupCurrentOriginUrl(child.href);
                            return (
                              <div key={child.id} className="col-12">
                                {childHref ? (
                                  <Link href={childHref} color="text.secondary" underline="hover">
                                    <Typography component="span" variant="body1" color="text.secondary">
                                      {child.label}
                                    </Typography>
                                  </Link>
                                ) : (
                                  <Typography component="span" variant="body1" color="text.secondary">
                                    {child.label}
                                  </Typography>
                                )}
                              </div>
                            );
                          })}
                        </div>
                        {openFooterTab[parent.id] && (
                          <div className="row gy-3 pt-2 d-md-none">
                            {parent.links.map((child) => {
                              const childHref = setupCurrentOriginUrl(child.href);
                              return (
                                <div key={child.id} className="col-12">
                                  {childHref ? (
                                    <Link href={childHref} color="text.secondary" underline="hover">
                                      <Typography component="span" variant="body1" color="text.secondary">
                                        {child.label}
                                      </Typography>
                                    </Link>
                                  ) : (
                                    <Typography component="span" variant="body1" color="text.secondary">
                                      {child.label}
                                    </Typography>
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </>
                    )}
                  </div>
                );
              })}
          </div>
        </div>
      </section>
      <section className="bg-black px-3 py-4">
        <div className="container-xl">
          <div className="row gy-3">
            <div className="col-12 col-md-4 col-lg-6">
              {data?.footerLogo?.data?.attributes && (
                <div className="d-flex w-100 h-100 align-items-center justify-content-center justify-content-md-start ">
                  <img
                    src={setupContentUrl(data.footerLogo.data.attributes.url)}
                    alt={data.footerLogo.data.attributes.alternativeText ?? ''}
                    style={{
                      width: data.footerLogo.data.attributes.width ?? undefined,
                      height: data.footerLogo.data.attributes.height ?? undefined,
                    }}
                  />
                </div>
              )}
            </div>
            <div className="col-12 col-md-8 col-lg-6">
              <div className="row mb-3 gx-1 gy-2">
                <div className="col-12">
                  <Typography component="span" variant="body1" color="white">
                    {labels?.['store_label']}
                  </Typography>
                </div>
                {STORES.map(({ Icon, img, label, href, styles }, id) => (
                  <div key={id} className="col-auto">
                    <IconButton component="a" href={href} color="inherit" size="large" className="rounded-0">
                      {Icon ? (
                        <Icon alt={label} style={styles} className="text-white" />
                      ) : (
                        <img src={img} alt={label} style={styles} className="text-white" />
                      )}
                    </IconButton>
                  </div>
                ))}
              </div>
              <div className="row gx-1 gy-2">
                {SOCIAL.map(({ Icon, img, label, href, styles }, id) => (
                  <div className="col-auto" key={id}>
                    <IconButton component="a" href={href} color="inherit" size="large">
                      {Icon ? (
                        <Icon alt={label} style={styles} className="text-white" />
                      ) : (
                        <img src={img} alt={label} style={styles} className="text-white" />
                      )}
                    </IconButton>
                  </div>
                ))}
              </div>
            </div>
            <div className="col-12">
              <div className="row gx-4 gy-3 gy-md-2">
                {Array.isArray(data?.links) &&
                  data.links.map((it) => {
                    const itemHref = setupCurrentOriginUrl(it.href);
                    return (
                      <div key={it.id} className="col-12 col-md-auto">
                        {itemHref ? (
                          <Link href={itemHref} color="white" underline="hover">
                            <Typography component="span" variant="body1" color="white">
                              {it.label}
                            </Typography>
                          </Link>
                        ) : (
                          <Typography component="span" variant="body1" color="white">
                            {it.label}
                          </Typography>
                        )}
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
      </section>
    </footer>
  );
};
export default Footer;
